export default __webpack_public_path__ + "b711e2aabad84cd55e9979812c9cd4bc.png";